// src/components/shared/FPLLogo.jsx
import React from 'react';

/**
 * FPL crest logo.
 * @param {'full'|'icon'} size     - 'full' = wider aspect, 'icon' = square crest only
 * @param {'light'|'dark'} colour  - 'light' = white, 'dark' = original purple (#3D195B)
 * @param {string} className       - additional CSS classes
 */
const FPLLogo = ({ size = 'full', colour = 'light', className = '' }) => {
  const filter = colour === 'light' ? 'brightness(0) invert(1)' : 'none';

  if (size === 'icon') {
    return (
      <img
        src="/images/fpl_logo.svg"
        alt="FPL"
        className={className}
        style={{ filter, display: 'inline-block' }}
        aria-label="Fantasy Premier League"
      />
    );
  }

  // Full — logo + "Wrapped" wordmark beside it
  return (
    <div className={`flex items-center gap-3 ${className}`} aria-label="FPL Wrapped">
      <img
        src="/images/fpl_logo.svg"
        alt="FPL"
        style={{ filter, height: '100%', width: 'auto' }}
      />
      <span
        style={{
          fontWeight: 700,
          fontSize: 'inherit',
          letterSpacing: '-0.02em',
          color: colour === 'light' ? '#ffffff' : '#3D195B',
        }}
      >
        Wrapped
      </span>
    </div>
  );
};

export default FPLLogo;
